import { memo } from 'react'
import PropTypes from 'prop-types'

import { ConfirmationDialog } from '@collaborate-health/uikit'

const DeleteReportConfirmationDialog = ({ open, onClose, onSubmit }) => {
  return (
    <ConfirmationDialog
      isOpen={open}
      onCloseDialog={onClose}
      onSubmit={onSubmit}
      title='Are you sure you want to delete this report?'
      submitButtonText='Yes'
      cancelButtonText='No'
    />
  )
}

DeleteReportConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default memo(DeleteReportConfirmationDialog)
